/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FlipVerticalIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Flip Vertical',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M2 16h2v2H2zM6 16h2v2H6zM10 16h2v2h-2zM14 16h2v2h-2zM18 16h2v2h-2zM22 16h2v2h-2zM26 16h2v2h-2zM30 16h2v2h-2zM5.3 30.249l10.9-10.072a1.01 1.01 0 0 1 1.428 0L28.7 30.249a1.01 1.01 0 0 1-.714 1.724H6.012a1.01 1.01 0 0 1-.712-1.724ZM25.921 3.818l-8.843 8.168L8.1 3.818ZM29 3.017A1.009 1.009 0 0 0 27.988 2H6.012A1.009 1.009 0 0 0 5 3.018a.987.987 0 0 0 .3.706L16.367 13.8a1.01 1.01 0 0 0 1.428 0L28.7 3.724a.989.989 0 0 0 .3-.707Z"
    />
  </svg>`;
};
